"use client";
import { jsx } from "react/jsx-runtime";
import { useSvg } from "../../../hooks/useSvg.js";
import { sharedHandler } from "../../../shared/sharedHandler/sharedHandler.js";
import { rem, Box } from "@mantine/core";
import { forwardRef } from "react";
import "../Icon/Icon.js";
import { resolveIconColor } from "../Icon/Icon.helpers.js";
import { B as BrandsList } from "./items/index.js";
import '../../../assets/Brand.css';const root = "_root_1egp3_2";
const BrandStyles = {
  root
};
const _Brand = forwardRef(
  ({
    name,
    variant = "dark",
    href,
    target,
    className,
    mod,
    width = "auto",
    height = "auto",
    style,
    color = "light",
    ...rest
  }, ref) => {
    const Svg = useSvg(name, BrandsList);
    const styleVariables = {
      "--passed-height": rem(height),
      "--passed-width": rem(width),
      "--passed-color": resolveIconColor(color)
    };
    return /* @__PURE__ */ jsx(
      Box,
      {
        ...rest,
        ref,
        style: { ...styleVariables, ...style },
        className: `${BrandStyles.root} ${className}`,
        mod: { variant, ...mod },
        component: href ? "a" : "div",
        target: target || void 0,
        href: href || void 0,
        "aria-label": name.replace("Logo", ""),
        children: Svg
      }
    );
  }
);
_Brand.displayName = "Brand";
const Brand = sharedHandler(_Brand);
Brand.displayName = _Brand.displayName;
export {
  BrandStyles as B,
  Brand as default
};
